import * as Yup from "yup";
import INFragment from "./INFragment";

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Yup.InferType<typeof schema>;

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["IN"]).required("Required"),
  inIsRemoteWork: Yup.boolean().required("Required"),
  probationPeriodDays: Yup.string()
    .required("Required")
    .oneOf(["0", "90"], "Must be none or 90 days."),
});

const CONFIG: ConfigType = {
  component: <INFragment />,
  schema: schema,
  initialValues: {
    workCountry: "IN",
    inIsRemoteWork: false,
    probationPeriodDays: "0",
  },
  keysToExclude: [],
};

export default CONFIG;
